// removed by extract-text-webpack-plugin
module.exports = {"link":"_2E7oeW0FBnTx1xbu_39Rpu","breadcrumbs":"FjyqpJtjz_Q9_sBBe_o1x"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/breadcrumb.css
// module id = 3057
// module chunks = 0